const defaultNfseModuleState = () => ({
  summaryNfses: [],
  paginationNfse: {
    perPage: 15,
    currentPage: 1,
  },
});

export const defaultGeneralInformationState = () => ({
  serie: {},
  natureOfOperation: {},
  user: {},
  art: null,
  culturalEncouraging: false,
  incidence: null,
  workCode: null,
  production: true,
  additionalInformation: null,
});

export const defaultReceiverState = () => ({
  id: null,
  remotePersonId: null,
  error: false,
  uuid: '',
  name: '',
  exportationDoc: '',
  businessName: '',
  identification: '',
  identificationFormatted: '',
  label: '',
  accountantCPF: null,
  CRC: null,
  stateCode: '',
  suframaCode: null,
  cityCode: null,
  site: null,
  image: null,
  rg: '',
  indicadorIE: null,
  contactPerson: '',
  observation: null,
  alert: null,
  active: null,
  creditLimit: null,
  isAccountant: null,
  isClient: null,
  isSupplier: null,
  isDelivery: null,
  isRural: null,
  personType: null,
  balanceLimit: null,
  created: '',
  emailCollection: [],
  phone: {
    countryCode: null,
    areaCode: null,
    number: '',
    type: null,
    id: null,
  },
  address: {
    identification: null,
    number: '',
    complement: '',
    street: '',
    neighbourhood: '',
    type: null,
    isForeign: null,
    id: null,
    zipCode: {
      id: null,
      street: '',
      neighbourhood: '',
      zipCode: '',
      city: {
        id: null,
        name: '',
        code: '',
        state: {
          id: null,
          name: '',
          acronym: '',
          code: null,
          country: {
            name: '',
            acronym: '',
            fiscalId: '',
            id: null,
          },
        },
      },
    },
  },
  creditLimitBalance: null,
  overdueDaysAvg: null,
  firstBuyDate: null,
  lastBuyDate: null,
  activity: {
    id: null,
    name: '',
  },
});

export const defaultServicesState = () => ({
  nbs: [],
  cityTaxCode: null,
  serviceCollection: [],
});

export const defaultTaxesState = () => ({
  issExibility: {},
  responsibleRetention: {},
  uf: {},
  city: {},
  cityTaxCode: null,
  servicesValue: 0,
  retainedIss: false,
  liquidValue: 0,
  retainedIssValue: 0,
  issValue: 0,
  cofinsPercentage: 0,
  cofinsValue: 0,
  pisPercentage: 0,
  pisValue: 0,
  inssPercentage: 0,
  inssValue: 0,
  irPercentage: 0,
  irValue: 0,
  csllPercentage: 0,
  csllValue: 0,
  issPercentage: 0,
  deductionsValue: 0,
  otherRetentionsValue: 0,
  calculationBasis: 0,
  discount: 0,
  discountType: 0,
  total: 0,
  calcTypes: [],
});

export const defaultPaymentsState = () => ({
  edited: false,
  paymentModeCollection: [],
  remainder: 0,
});

export const defaultNfseState = () => ({
  nfse: {
    id: null,
    status: null,
    generalInformation: { ...defaultGeneralInformationState() },
    receiver: { ...defaultReceiverState() },
    services: { ...defaultServicesState() },
    taxes: { ...defaultTaxesState() },
    payments: { ...defaultPaymentsState() },
  },
});

const initialState = {
  ...defaultNfseModuleState(),
  ...defaultNfseState(),
  warningsNfse: [],
  fiscalValidation: null,
  tableKey: 0,
};

export default {
  ...initialState,
};
